import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { api } from '../../utils/api'

/**
 * /i/:productId — the short deep link printed as a QR code on warehouse
 * labels (kept short to hold the QR module count down). Resolves the product
 * and lands on the inventory list with the Edit Product modal open; if the id
 * doesn't resolve, falls back to the list with the id pre-searched so the
 * operator can take it from there.
 *
 * Lives inside ProtectedRoute, so a signed-out phone scanning a label bounces
 * through /login and returns here automatically (Login honours state.from).
 */
function ProductDeepLink() {
  const { productId } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    let cancelled = false
    const cleanId = String(productId || '').replace(/\D/g, '')

    async function resolve() {
      if (!cleanId) {
        navigate('/inventory/list', { replace: true })
        return
      }
      let found = false
      try {
        const response = await api.get(`/api/inventory/shopify/search?product_id=${cleanId}&stock_status=all`)
        found = (response.products || []).length > 0
      } catch (err) {
        console.error('Deep link lookup failed:', err)
      }
      if (cancelled) return
      navigate(
        found
          ? `/inventory/list?productId=${cleanId}&open=1`
          : `/inventory/list?q=${cleanId}`,
        { replace: true }
      )
    }

    resolve()
    return () => { cancelled = true }
  }, [productId, navigate])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 'var(--space-12)' }}>
      <div className="loading-spinner" />
    </div>
  )
}

export default ProductDeepLink
